import axios from "../util/axiosConfig";

import { getErrorMessageV2 } from "../util/ErrorUtils";

export const fetchDeviceActAPI = async () => {
  return await axios
    .get(`/api/v1/healthsystems/device-activation`)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessageV2(error) };
    });
};

export const activateDeviceAPI = async (payload) => {
  return await axios
    .post(`/api/v1/healthsystems/device/activate`, payload)
    .then((response) => {
      if (response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false };
      }
    })
    .catch((error) => {
      return { success: false, error: getErrorMessageV2(error) };
    });
};
